import { useMutation } from '@zenbusiness/application-commons-graphql';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useLogError } from '#client/hooks/useLogError';
import { CREATE_INSTANT_FUNDING_ACCOUNT } from '#client/mutations';

const useCreateInstantFundingAccount = () => {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const [mutation, { data, loading, error, errors }] = useMutation(CREATE_INSTANT_FUNDING_ACCOUNT, {
    noThrow: true
  });

  useLogError(errors, error);

  const createInstantFundingAccount = async () => {
    const response = await mutation({
      variables: {
        businessEntityUuid
      }
    });

    return response;
  };

  return {
    data,
    createInstantFundingAccount,
    loading,
    error
  };
};

export default useCreateInstantFundingAccount;
